import { time } from '@/time';
import type { Recipe } from '@/types';

const recipe: Recipe = {
  title: 'Pulled Pork',
  source: 'https://www.seriouseats.com/sous-vide-barbecue-pulled-pork-shoulder-recipe',
  totalTime: time(19, 55),
  servings: 12,
  tags: { type: 'main' },
  vessels: { main: { kind: 'sheet-pan', width: 13, height: 18 } },
  ingredients: [
    { name: 'BBQ pork rub', quantity: '1', unit: 'recipe', customUnit: true,
      recipe: 'bbq-pork-rub',
    },
    { name: 'pork butt', quantity: '6', unit: 'lb',
    },
    { name: 'liquid hickory smoke', quantity: '1/2', unit: 'tsp',
      note: 'optional',
    },
    { name: 'BBQ sauce',
      recipe: 'bbq-sauce',
    },
  ],
  directions: [
    {
      title: 'Season & seal',
      bullets: [
        "Rub {BBQ pork rub:half} over {pork butt}, pressing until it adheres",
        "Place pork in sous vide bag",
        "Add {liquid hickory smoke} (optional)",
        "Seal pork in bag",
      ],
    },
    {
      title: 'Sous vide',
      bullets: [
        "Cook at {!165F} for 18–24h",
      ],
    },
    {
      title: 'Finish',
      bullets: [
        "Preheat oven to {!300F} with rack in lower-middle position",
        "Remove pork from bag & blot with paper towels",
        "Reserve cooking liquid in sous vide bag",
        "Rub with remaining {BBQ pork rub:half}",
        "Set wire rack in {vessel} & place pork on rack",
        "Roast ~1 1/2h, until a deep, dark bark forms",
      ],
    },
    {
      title: 'Shred & serve',
      bullets: [
        "Transfer pork to large bowl & shred into bite-size pieces",
        "Pour reserved cooking liquid over & mix",
        "Serve with {BBQ sauce}",
      ],
    },
  ],
};

export default recipe;
